import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { FormsModule, NgForm, NgModel } from '@angular/forms';
import { LookUpService } from '../../../services/lookupservice';
import { FeedstockService } from '../../../services/feedstockservice';
import { AttachDocumentsDialogData, DockTypesResponse } from '../../../interfaces/sitelockcodes';
import { DragDropModule } from '@angular/cdk/drag-drop';
interface StoredFile {
  name: string;
  type: string;
  data: string;
}

interface DocumentGroup {
  docTypeId: number;
  docTypeName: string;
  files: StoredFile[];
}
@Component({
  selector: 'app-attach-documents',
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    DragDropModule
  ],
  templateUrl: './attach-documents.component.html',
  styleUrl: './attach-documents.component.scss'
})
export class AttachDocumentsComponent implements OnInit {

  @ViewChild('attachDocForm') attachDocForm!: NgForm;
  @ViewChild('docTypeInput') docTypeInput!: NgModel;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  disableAddMoreFiles = false;
  dialogTitle: string = '';
  docTypes: DockTypesResponse[] = [];
  isUploadEnabled: boolean = false;
  screenTypeId: number = 0;
  loadScheduleId: number = 0;
  docTypeId: number | null = null;
  allowedExtensions = ['.jpg', '.jpeg', '.png', '.bmp', '.gif', '.pdf'];
  selectedFiles: File[] = [];          // temp (before upload)
  documents: DocumentGroup[] = [];    // saved data
  constructor(
    public dialogRef: MatDialogRef<AttachDocumentsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AttachDocumentsDialogData,
    private lookUpService: LookUpService,
    private feedstockService: FeedstockService
  ) {
    console.log("attachments", data);
    this.loadScheduleId = data.loadScheduleId;
    this.screenTypeId = data.screenTypeId;
    this.dialogTitle = data.name;
    this.disableAddMoreFiles = data.disableAddMoreFiles;
    const storedDocs = localStorage.getItem('documents');

    if (storedDocs) {
      const parsed = JSON.parse(storedDocs);

      // ✅ Ensure it's array
      this.documents = Array.isArray(parsed) ? parsed : [];
    } else {
      this.documents = [];
    }
  }

  ngOnInit(): void {
    this.getDepackDocTypes();
  }

  getDepackDocTypes(): void {
    this.lookUpService.getDocTypeByScreenType(this.screenTypeId).subscribe({
      next: (data: DockTypesResponse[]) => {
        this.docTypes = data;
        this.docTypeId = null;
      }
    });
  }
  onDocTypeChange(): void {
    this.isUploadEnabled = !!this.docTypeId;

    if (!this.docTypeId) return;
  }
  async onFileSelected(event: Event): Promise<void> {

    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      return;
    }

    await this.processFiles(Array.from(input.files));

    input.value = '';
  }
  private async processFiles(files: File[]): Promise<void> {

    // Validate doc type
    //if (!this.docTypeId) {

    //  this.attachDocForm.controls['docTypeId']
    //    ?.setErrors({ required: true });

    //  return;
    //}

    // Validate extensions
    const invalidFiles = files.filter(file => {

      const ext =
        '.' + file.name.split('.').pop()?.toLowerCase();

      return !this.allowedExtensions.includes(ext);
    });

    if (invalidFiles.length > 0) {

      this.attachDocForm.controls['loadSlipFiles']
        ?.setErrors({ invalidFileType: true });

      return;
    }

    this.selectedFiles = [
      ...this.selectedFiles,
      ...files
    ];

    const base64Files: StoredFile[] = [];

    for (const file of files) {
      base64Files.push(await this.toBase64(file));
    }

    const selectedDocType =
      this.docTypes.find(d => d.id === this.docTypeId);

    const docTypeName =
      selectedDocType?.docType || '';

    if (!Array.isArray(this.documents)) {
      this.documents = [];
    }

    const index =
      this.documents.findIndex(
        d => d.docTypeId === this.docTypeId
      );

    if (index > -1) {

      this.documents[index].files = [

        ...this.documents[index].files,

        ...base64Files.filter(newFile =>
          !this.documents[index].files.some(
            existing => existing.name === newFile.name
          )
        )
      ];

    } else {

      this.documents.push({
        docTypeId: this.docTypeId!,
        docTypeName,
        files: base64Files
      });
    }

    this.documents = [...this.documents];

    localStorage.setItem(
      'documents',
      JSON.stringify(this.documents)
    );
  }
  onUploadDocument(): void {
    let isValid = true;

    if (!this.docTypeId) {
      this.docTypeInput.control.markAsTouched();
      this.docTypeInput.control.markAsDirty();
      this.docTypeInput.control.updateValueAndValidity();

      isValid = false;
    }

    if (this.selectedFiles.length === 0) {
      this.attachDocForm.controls['loadSlipFiles']
        ?.setErrors({ required: true });

      isValid = false;
    }

    if (!isValid) {
      return;
    }
    if (!this.documents || this.documents.length === 0) {
      return;
    }

    // Upload each file individually so each retains its selected docType
    this.documents.forEach(doc => {
      doc.files.forEach(file => {
        const formData = new FormData();

        formData.append('loadScheduleId', this.loadScheduleId.toString());
        // use the group's docTypeId
        formData.append('docTypeId', (doc.docTypeId ?? 0).toString());
        formData.append('screenTypeId', this.screenTypeId.toString());

        const blob = this.base64ToBlob(file.data, file.type);
        formData.append('files', blob, file.name);

        this.feedstockService.uploadLoadDocument(formData).subscribe({
          next: () => {
            console.log(`Uploaded file ${file.name} for docType ${doc.docTypeId}`);
          }
        });
      });
    });

    // clear storage
    localStorage.removeItem('documents');

    this.documents = [];

    this.dialogRef.close(true);
  }

  async onAddMoreFiles(): Promise<void> {
    if (!this.docTypeId || this.selectedFiles.length === 0) return;

    const base64Files: StoredFile[] = [];

    for (let file of this.selectedFiles) {
      const converted = await this.toBase64(file);
      base64Files.push(converted);
    }

    // ✅ Get doc type from dropdown
    const selectedDocType = this.docTypes.find(d => d.id === this.docTypeId);
    const docTypeName = selectedDocType?.docType || '';

    const newEntry: DocumentGroup = {
      docTypeId: this.docTypeId,
      docTypeName: docTypeName,
      files: base64Files
    };

    // ✅ Ensure documents is array (important fix)
    if (!Array.isArray(this.documents)) {
      this.documents = [];
    }

    const index = this.documents.findIndex(d => d.docTypeId === this.docTypeId);

    if (index > -1) {
      this.documents[index].files = [
        ...this.documents[index].files,
        ...base64Files
      ];
    } else {
      this.documents.push(newEntry);
    }

    localStorage.setItem('documents', JSON.stringify(this.documents));

    // reset
    this.selectedFiles = [];
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
  }
  removeDocType(docTypeId: number): void {
    this.documents = this.documents.filter(d => d.docTypeId !== docTypeId);

    // update localStorage
    localStorage.setItem('documents', JSON.stringify(this.documents));
  }

  downloadFile(file: StoredFile): void {
    const link = document.createElement('a');
    link.href = file.data;
    link.download = file.name;
    link.click();
  }
  removeSelectedFile(file: File): void {
    this.selectedFiles = this.selectedFiles.filter(f => f !== file);

    if (this.selectedFiles.length === 0 && this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
  }
  removeFile(docTypeId: number, file: StoredFile): void {
    const doc = this.documents.find(d => d.docTypeId === docTypeId);
    if (!doc) return;

    doc.files = doc.files.filter(f => f.name !== file.name);

    if (doc.files.length === 0) {
      this.documents = this.documents.filter(d => d.docTypeId !== docTypeId);
    }

    localStorage.setItem('documents', JSON.stringify(this.documents));
  }

  onClose(): void {
    this.dialogRef.close(false);
  }
  onDragOver(event: DragEvent): void {
    event.preventDefault();   // Required for drop to work
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();

    if (!event.dataTransfer?.files?.length) {
      return;
    }

    this.processFiles(Array.from(event.dataTransfer.files));
  }
  trackById(index: number, item: DockTypesResponse): number {
    return item.id;
  }
  base64ToBlob(base64: string, contentType: string): Blob {

    const byteCharacters =
      atob(base64.split(',')[1]);

    const byteNumbers =
      new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] =
        byteCharacters.charCodeAt(i);
    }

    const byteArray =
      new Uint8Array(byteNumbers);

    return new Blob(
      [byteArray],
      { type: contentType }
    );
  }
  toBase64(file: File): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve({
        name: file.name,
        type: file.type,
        data: reader.result
      });
      reader.onerror = error => reject(error);
    });
  }
}

